import React from 'react';
import { useTranslation } from 'react-i18next';
import './ComingSoon.css';

interface ComingSoonProps {
  storeId?: string;
  reason?: 'no-store' | 'no-data' | 'invalid-store';
}

const ComingSoon: React.FC<ComingSoonProps> = ({ storeId, reason = 'no-data' }) => {
  const { t } = useTranslation();

  const getReasonConfig = () => {
    switch (reason) {
      case 'no-store':
        return {
          icon: '🚫',
          title: t('storeNotFound'),
          description: t('storeNotFoundDesc'),
          showContact: true
        };
      case 'invalid-store':
        return {
          icon: '⚠️',
          title: t('invalidStoreId'),
          description: t('invalidStoreIdDesc'),
          showContact: true
        };
      case 'no-data':
      default:
        return {
          icon: '📊',
          title: t('dashboardComingSoon'),
          description: t('dashboardComingSoonDesc'),
          showContact: false
        };
    }
  };

  const config = getReasonConfig();

  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <div className="coming-soon-icon">
          {config.icon}
        </div>
        
        <h1 className="coming-soon-title">
          {config.title}
        </h1>
        
        <p className="coming-soon-description">
          {config.description}
        </p>
        
        {config.showContact && (
          <div className="contact-info">
            <span className="contact-message">
              {t('contactManager')}
            </span>
          </div>
        )}
        
        <div className="coming-soon-animation">
          <div className="pulse-dot"></div>
          <div className="pulse-dot"></div>
          <div className="pulse-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;